import React from 'react';
import Select from "react-select";

const CustomDropdown = (props) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ marginBottom: '5px', marginLeft: '5px' }}>
                <span style={{ fontSize: '16px', color: 'grey', fontWeight: '500' }}>{props.title}</span>
            </div>
            <div>
                <Select
                    defaultValue={props?.defaultValue}
                    value={props?.value}
                    name={props?.name}
                    options={props?.options}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={(selection) => { props.onChange(selection) }}
                    isMulti={props?.isMulti || false}
                />
            </div>
        </div>
    );
};

export default CustomDropdown;

